import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBusinessNameContactService from '../../../app/services/hooks/useBusinessNameContactService';

interface Props {
    businessNameContactId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BusinessNameContactSwitchChange = ({ businessNameContactId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBusinessNameContact, fetchingActiveBusinessNameContact } = useBusinessNameContactService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBusinessNameContact(businessNameContactId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={businessNameContactId} callback={active} />;
};

export default BusinessNameContactSwitchChange;
